// MaxWidth.js
import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class MaxWidth extends BaseOption {
  static userInterfaceComponent = {
    label: "Max Width",
    component: inspectorTools.AUTOCOMPLETE,
    props: {
      showAllResultsOnClick: true,
      items: [
        { value: "fixed", label: "Fixed", action: true },
        { value: "unset", label: "unset" },
      ],
      prefix: "Max W:",
      suffix: "px",
      itemValueKey: "value",
      itemLabelKey: "label",
      allowCustomValue: true,
      subtleValueVariants: ["unset"],
      placeholder: "Max Width",
    },
  };

  static defaultValue = "unset";

  static getCssValue(option) {
    if (option === "unset") {
      return "unset";
    }
    return option + "px";
  }
}
